import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    margin: '8px 0',
    width: '100%'
  },
  adminRoot: { opacity: '50%' },
  top: { padding: theme.spacing(2) },
  bottom: { padding: theme.spacing(2) },
  section: {
    padding: theme.spacing(1, 2)
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  subHeader: {
    display: 'flex',
    marginBottom: 12
  },
  label: {
    color: theme.palette.grey[700],
    marginRight: 4,
    marginBottom: 8
  },
  value: {
    color: theme.palette.text.primary
  },
  channelName: { color: theme.palette.text.primary, fontFamily: 'IranSans' },
  row: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.grey[200],
    borderRadius: 6,
    padding: theme.spacing(2),
    gap: 8,
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1)
    }
  },
  guestRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  avatar: {
    width: 36,
    height: 36,
    borderRadius: '50%',
    display: 'inline-block'
  },
  tag: {
    backgroundColor: theme.palette.grey[200],
    borderRadius: 8,
    padding: '2px 6px',
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    marginLeft: theme.spacing(1)
  },
  redText: {
    color: theme.palette.primary.main,
    marginTop: 6
  },
  yellowText: {
    marginTop: 6,
    color: theme.palette.warning.main
  },
  blueText: {
    marginTop: 6,
    color: theme.palette.info.main
  },
  container: {
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    padding: theme.spacing(2),
    gap: 16,
    flex: '0 0 auto',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  left: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8
  },
  right: {},
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    fontSize: 16
  },
  blackText: { fontWeight: 500, color: theme.palette.text.primary },
  iconText: {
    display: 'flex',
    verticalAlign: 'middle',
    fontWeight: 600,
    lineHeight: '22px',
    fontSize: 18,
    padding: theme.spacing(0, 1.5),
    color: theme.palette.text.primary,

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  roomTypeText: {
    display: 'flex',
    verticalAlign: 'middle',
    fontWeight: 500,
    lineHeight: '20px',
    fontSize: 18,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
    color: theme.palette.text.primary
  },
  icon: { fontSize: 20, marginRight: 6 },
  iconTextSmall: {
    display: 'flex',
    verticalAlign: 'middle',
    fontWeight: 600,
    color: theme.palette.grey[700],
    fontSize: 12,
    lineHeight: '21px'
  },
  horixental: { display: 'flex' },
  Reserve: {
    marginBottom: 24,
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      marginBottom: 12
    }
  },
  check: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start'
    }
  },
  greyText: { fontWeight: 500, color: theme.palette.grey[700] },
  cancelText: { fontWeight: 600, color: theme.palette.error.dark },
  phoneText: {
    fontWeight: 500,
    color: theme.palette.grey[700],
    marginRight: 16
  },
  personCard: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 6,
    backgroundColor: theme.palette.grey[200],
    margin: '8px 0'
  },
  profileIcon: {
    fontSize: 20,
    color: theme.palette.grey[700],
    marginRight: 4
  },
  detailsBox: {
    paddingLeft: theme.spacing(2),
    display: 'grid',
    gridTemplateRows: '1fr 1fr',
    gap: theme.spacing(1),
    borderLeft: `1px solid ${theme.palette.grey[400]}`,
    padding: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      gridTemplateRows: '1fr'
    }
  },
  policy: {
    background: theme.palette.grey[200],
    borderRadius: 6,
    width: '100%',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  error: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 6,
    border: `1px solid ${theme.palette.primary.main}`,
    background: theme.palette.primary.light,
    padding: theme.spacing(1.5),
    marginTop: 0
  },
  verticalAlign: {
    display: 'flex',
    verticalAlign: 'middle',
    fontSize: 12,
    color: theme.palette.primary.main
  },
  iconSmall: {
    fontSize: 12,
    marginLeft: 4,
    height: 21
  },
  formIcon: {
    color: theme.palette.grey[500],
    fontSize: 18,
    marginRight: 8,
    alignSelf: 'center'
  },
  row2: { display: 'flex', alignItems: 'center', marginRight: 16 }
}))
